import { Component, OnInit, ViewChild,ElementRef } from '@angular/core';
import { SharedService } from '../../_service/shared.service';
import { ActivatedRoute, Router  } from '@angular/router';
import {PageEvent, MatPaginator} from '@angular/material/paginator';
import { MiscService } from '../../_service/misc.service';

declare var $: any;
@Component({
  selector: 'app-ipd-resources',
  templateUrl: './ipd-resources.component.html',
  styleUrls: ['./ipd-resources.component.css']
})
export class IpdResourcesComponent implements OnInit {

  @ViewChild(MatPaginator) paginator: MatPaginator;

  perpage:number=25;IpdResourcesList:any=[];length:number=0;pageEvent: PageEvent;loading:boolean=true;myrole:string;
    pageSizeOptions = [10,25,50,100,200];pageIndex:number=0;loaded:boolean=false;
    search:string;status='';pageType='';PageTitle:string;pageLink:string;
    
    constructor(private sharedapi:SharedService,public miscapi:MiscService,private activatedRoute: ActivatedRoute) 
    { 
        this.activatedRoute.params.subscribe(params => 
        {
          if (params['page_type']) 
          {
              this.pageType = params['page_type'];
              if(this.pageType=='1'){
                this.PageTitle='Consumables';
                this.pageLink='consumables'
              }else if(this.pageType=='2'){
                this.PageTitle='Lapset Vendor';
                this.pageLink='lapset-vendor'
              }else if(this.pageType=='3'){
                this.PageTitle='Anaesthetist';
                this.pageLink='anaesthetist'
              }else if(this.pageType=='4'){
                this.PageTitle='Rental';
                this.pageLink='rental'
              }
          }
        });

    }

    ngOnInit(): void 
    {
        this.sharedapi.getRole()
        .subscribe((item:string) => {this.myrole=item;});
        this.myrole = localStorage.getItem('role');
        
    }
   
    ngAfterViewInit() {
         this.loadIpdResourcesList(0,this.perpage);
    }

    async loadIpdResourcesList(pageIndex,perpage)
    {
    	  this.IpdResourcesList = [];
        let pageType=this.pageType;
        this.paginator.pageIndex = pageIndex; 
    	  let qString = 'search='+this.search+'&status='+this.status;
        this.loading = true;this.loaded = false;
        this.miscapi.getIpdResourcesList(pageType,this.paginator.pageIndex,perpage,qString).subscribe((data:any) => 
        {
            this.length = parseInt(data.totaldata);
            this.loading = false;
            this.loaded = true;
            if(data.status)
            {
                this.IpdResourcesList = data.data;
            }else{
                this.IpdResourcesList = [];
            }
        }, error => {
            this.loading = false;
            this.loaded = true;
            this.sharedapi.checkError(error);
        });
    }

    pageChange(event)
    {
        this.pageIndex = event.pageIndex;
        this.loadIpdResourcesList(event.pageIndex,event.pageSize);
    }

    public getServerData(event:PageEvent):any
    {
        this.perpage = event.pageSize;
        this.pageIndex = event.pageIndex;
        this.loadIpdResourcesList(event.pageIndex,event.pageSize);
    }
}